var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"fac-radio",class:[_vm.design, { inline: _vm.inline }]},[_c('input',{attrs:{"type":"radio","name":_vm.name},domProps:{"value":_vm.value,"checked":_vm.checked},on:{"change":_vm.onChange}}),_c('span',[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }